import { convertInlineStyleToReactStyleObj } from 'crazyEditor/core/utils/styleUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import _ from 'lodash';
import $ from 'jquery';
import { initChildElements } from 'crazyEditor/redux/modules/element/helpers/elementChildrenHelpers';
import { getElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';

function filterCompProps(compProps) {
  const filteredCompProps = _.omit(compProps, ['width', 'height', 'top', 'left', 'position', 'cursor', 'transform']);
  if (_.isString(filteredCompProps.zIndex)) {
    filteredCompProps.zIndex = parseInt(filteredCompProps.zIndex, 10);
  }
  return filteredCompProps;
}

function filterDataCompProps(compProps) {
  return _.omit(filterCompProps(compProps), ['zIndex']);
}

function getElementLayout(element, compProps) {
  const $element = $(element.outerHTML);
  return {
    x: parseInt(compProps.left, 10),
    y: parseInt(compProps.top, 10),
    height: $element.outerHeight(),
    width: $element.outerWidth(),
  };
}

export const getTitleElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const dataEl = element.children[0];
  const linkEl = element.querySelector('a');
  const text = dataEl.innerHTML;
  const dataCompProps = convertInlineStyleToReactStyleObj(dataEl.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.TitleElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      text: text,
      compProps: filterDataCompProps(dataCompProps || {}),
      href: linkEl && linkEl.getAttribute('href') || ''
    }
  };
};

export const getRichTextElementStructure = (element, tabChild = false) => {
  if (tabChild === false && element.parentElement.classList.contains('ui-tabs-panel')) {
    return null;
  }
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  let filteredCompProps = filterCompProps(compProps);
  if (tabChild) {
    filteredCompProps = getElementPreset(elementTypes.RichTextElement).compProps;
    compProps.top = 0;
    compProps.left = 0;
  }
  const dataEl = element.children[0];
  const dataCompProps = convertInlineStyleToReactStyleObj(dataEl.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.RichTextElement,
    compProps: filteredCompProps,
    layout: getElementLayout(element, compProps),
    data: {
      rawHTML: dataEl.innerHTML,
      compProps: filterDataCompProps(dataCompProps || {})
    }
  };
};

export const getImageElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const imgEl = element.querySelector('img');
  if (!imgEl) {
    return null;
  }
  const linkEl = element.querySelector('a');
  const dataCompProps = convertInlineStyleToReactStyleObj(imgEl.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.ImageElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      url: imgEl.getAttribute('src'),
      title: imgEl.getAttribute('title') || '',
      altText: imgEl.getAttribute('alt') || '',
      href: linkEl && linkEl.getAttribute('href') || '',
      compProps: filterDataCompProps(dataCompProps || {})
    }
  };
};

export const getShapeElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.ShapeElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {}
  };
};

export const getIconElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const dataEl = element.querySelector('svg');
  const linkEl = element.querySelector('a');
  const dataCompProps = convertInlineStyleToReactStyleObj(dataEl.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.IconElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      rawSVG: dataEl.outerHTML,
      compProps: filterDataCompProps(dataCompProps || {}),
      href: linkEl && linkEl.getAttribute('href') || '',
    }
  };
};

export const getHtmlElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  let dataEl = element.querySelector('.htmlembed');
  if (!dataEl) {
    dataEl = element.querySelector(`#${compId}_htmlembed`);
  }
  const dataCompProps = convertInlineStyleToReactStyleObj(dataEl.getAttribute('style'));
  return {
    id: compId,
    type: elementTypes.HtmlElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      rawHTML: dataEl.innerHTML,
      compProps: filterDataCompProps(dataCompProps || {})
    }
  };
};

export const getVideoElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const dataElIframe = element.querySelector('iframe');
  const dataElObject = element.querySelector('object');
  let url = '';
  let dataCompProps;
  let videoId = '';
  if (dataElIframe) {
    url = dataElIframe.src;
    dataCompProps = convertInlineStyleToReactStyleObj(dataElIframe.getAttribute('style'));
  } else if (dataElObject) {
    url = 'https://www.youtube.com/embed/' + dataElObject.querySelector('param').value.split('/').pop();
    dataCompProps = convertInlineStyleToReactStyleObj(dataElObject.getAttribute('style'));
  }
  if (url) {
    videoId = url.split('/').pop().replace(/\?.*/, '');
  }
  return {
    id: compId,
    type: elementTypes.VideoElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      url: url,
      videoId: videoId,
      compProps: filterDataCompProps(dataCompProps || {})
    }
  };
};

export const getGalleryElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const dataEl = _.pickBy(element.querySelectorAll('.ad-thumb-list li'), (li) => {
    return (_.get(li, 'children.length') !== 0 && _.get(li, 'nodeName') === 'LI');
  });
  return {
    id: compId,
    type: elementTypes.GalleryElement,
    compProps: filterCompProps(compProps),
    layout: getElementLayout(element, compProps),
    data: {
      list: _.map(dataEl, (el) => el.getAttribute('val')),
      compProps: {}
    }
  };
};

const DEFAULT_TAB_BACKGROUND_COLOR = '#f7f7f7';
export const getTabsElementStructure = (element) => {
  const compId = element.id;
  const compProps = convertInlineStyleToReactStyleObj(element.getAttribute('style'));
  const tabsNav = element.querySelector('.ui-tabs-nav');
  const tabNameEls = element.querySelectorAll('.ui-tabs-anchor');
  const richTextElements = element.querySelectorAll('[data-element-type="Text"]');
  const tabChildren = [];
  const fontFamily = compProps.fontFamily;
  _.forEach(richTextElements, (element) => tabChildren.push(_.merge(getRichTextElementStructure(element, true))));
  const tabNames = _.map(tabNameEls, (tabNameEl) => tabNameEl.innerHTML);
  const tabCount = Math.min(tabNames.length, tabChildren.length);
  const tabElement = {
    id: compId,
    type: elementTypes.TabsElement,
    compProps: {..._.omit(filterCompProps(compProps), ['borderRadius', 'fontSize', 'border', 'fontFamily']), backgroundColor: DEFAULT_TAB_BACKGROUND_COLOR},
    layout: getElementLayout(element, compProps),
    data: {
      tabNames: tabNames.slice(0, tabCount),
      children: tabChildren.slice(0, tabCount),
      compProps: {fontFamily, ...convertInlineStyleToReactStyleObj(tabsNav.getAttribute('style'))}
    }
  };
  initChildElements(tabElement);
  return tabElement;
};

export const DESKTOP_ELEMENT_MAPPING = {
  Title: getTitleElementStructure,
  Text: getRichTextElementStructure,
  Image: getImageElementStructure,
  Shape: getShapeElementStructure,
  Icon: getIconElementStructure,
  Htmlembed: getHtmlElementStructure,
  Video: getVideoElementStructure,
  Gallery: getGalleryElementStructure,
  Tabs: getTabsElementStructure
};

export const getDesktopStructure = (templateHTML) => {
  const template = document.createElement('div');
  template.innerHTML = templateHTML;
  const desktopStructure = [];
  _.forEach(DESKTOP_ELEMENT_MAPPING, (elementConvertFn, elementType) => {
    const elements = template.querySelectorAll(`[data-element-type="${elementType}"]`);
    _.forEach(elements, (element) => {
      if (!_.isNil(element)) {
        if (element.style.display !== 'none') {
          const elementStructure = elementConvertFn(element);
          if (elementStructure) {
            if (_.isArray(elementStructure)) {
              desktopStructure.push.apply(desktopStructure, elementStructure);
            } else {
              desktopStructure.push(elementStructure);
            }
          }
        }
      }
    });
  });

  return desktopStructure;
};
